import RegisterControllerUI from "./RegisterUI"
import LoginUiController from "./loginUI"

class AuthenticationController {

    constructor(globalStore, init = true) {

        this.mainContainer = document.querySelector('.project-main')

        this.globalStore = globalStore || {}
        this.mainPanels = []
        
        if (init) this._init()
    }

    _init() {

        this.ui = this._makeConitainer()

        this.mainContainer.appendChild(this.ui)

        this.addEvents()

    }

    _makeConitainer() {

        let container = document.createElement('div')
        container.classList.add('authentication-container')

        let headerContainer = this._makeHeaderContainer()

        container.appendChild(headerContainer)

        this.__loginPanel = this._makeloginUi()
        container.appendChild(this.__loginPanel)
        this.mainPanels.push(this.__loginPanel)

        this.__registerPanel = this._makeRegisterUi()
        container.appendChild(this.__registerPanel)
        this.mainPanels.push(this.__registerPanel)
        return container
    }

    _makeHeaderContainer() {
        let container = document.createElement('div')

        container.classList.add('tab-controller')

        container.innerHTML = `       
            <span class="properties-ui-login-header">Login</span>
            <span class="properties-ui-register-header">Register</span>
        `

        return container

    }

    _makeloginUi() {

        let container = document.createElement('div')
        container.classList.add('login-panel')

        return container
    }

    _makeRegisterUi() {
        let container = document.createElement('div')
        container.classList.add('register-panel')

        return container
    }

    addEvents() {

        this.addEventsToPropertiesHeader()

    }

    unSelectPanels() {

        let transformHeader = this.ui.querySelector('.properties-ui-login-header')
        transformHeader.classList.remove('properties-ui-selected-header')


        let attributeHeader = this.ui.querySelector('.properties-ui-register-header')
        attributeHeader.classList.remove('properties-ui-selected-header')


    }

    
    __hideAllPanels() {

        this.mainPanels.forEach(panel => panel.style.display = 'none')

    }

    addEventsToPropertiesHeader() {


        this.loginformHeader = this.ui.querySelector('.properties-ui-login-header')

        this.loginformHeader.addEventListener('click', e => {

            this.__hideAllPanels()
            new LoginUiController(this, this.__loginPanel)
            this.__loginPanel.style.display = 'block'
            this.unSelectPanels()
            this.loginformHeader.classList.add('properties-ui-selected-header')

        })
        this.loginformHeader.click()


        this.registerHeader = this.ui.querySelector('.properties-ui-register-header')

        this.registerHeader.addEventListener('click', e => {

            this.__hideAllPanels()
            new RegisterControllerUI(this, this.__registerPanel)
            this.__registerPanel.style.display = 'Block'
            this.unSelectPanels()
            this.registerHeader.classList.add('properties-ui-selected-header')


        })



    }
}

export default AuthenticationController